import Request from './request';
import * as query from "@arcgis/core/rest/query";
import Query from "@arcgis/core/rest/support/Query";
import FieldNames from '../defaults/FieldNames.json';
import GeneralService from './GeneralService';
import { getAppConfig, getAttributeServiceUrl, getNifcToken } from '../utils/ReduxHelper';

const CustomFilterService = {
  getCustomFiltersByUser: function(userId) {
    try
    {
      const rootServiceUrl = getAttributeServiceUrl()
      const config = getAppConfig();
      const queryObject = new Query({
          where: `(UserID = '${userId}')`,
          outFields: "*",
          returnGeometry: false,
      });

      return query.executeQueryJSON(rootServiceUrl + "/" + config.userCustomFilters[config.env].layerId, queryObject).then(results => {
        let userItems = [];
        if(results.features) {
          userItems = results.features;
        } 
        return userItems
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  clearAllActiveCustomFilterByUser: function (userId, objectIDsActiveCustomFilters){
    try
    {
      const rootServiceUrl = getAttributeServiceUrl()
      const config = getAppConfig();
      const nifcToken = getNifcToken();

      return new Promise((resolve, reject) => {
        const allCustomFilterItemsToDeactivate = [];
        objectIDsActiveCustomFilters?.forEach(objectID => {
          let newItem = {attributes: {}};
          newItem.attributes[FieldNames.customFilter.objectID] = objectID;
          newItem.attributes[FieldNames.customFilter.isActive] = FieldNames.yesNo.no;
          allCustomFilterItemsToDeactivate.push(newItem);
        })
        
        if(allCustomFilterItemsToDeactivate?.length > 0){
          new Request().makeRequest({
            url: rootServiceUrl + "/" + config.userCustomFilters[config.env].layerId + '/updateFeatures',
            method: 'post',
            data: {
                f: 'json',
                token: nifcToken,
                features: JSON.stringify(allCustomFilterItemsToDeactivate)
            }
          }).then(
            resp => {
              resolve(resp)
            },
            error => {
              reject(error)
            }
          );
        }
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  addCustomFilter: function (customFilterInfo) {
    try
    {
      const rootServiceUrl = getAttributeServiceUrl()
      const config = getAppConfig();
      const nifcToken = getNifcToken();
      return new Promise((resolve, reject) => {
        new Request().makeRequest({
          url: rootServiceUrl + "/" + config.userCustomFilters[config.env].layerId + "/addFeatures",
          method: 'post',
          data: {
              f: 'json',
              token: nifcToken,
              features: JSON.stringify([customFilterInfo])
          }
        }).then(
            resp => {
              resolve(resp)
            },
            error => {
              reject(error)
            }
        );
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  updateCustomFilter: function (customFilterInfo) {
    try
    {
      const rootServiceUrl = getAttributeServiceUrl()
      const config = getAppConfig();
      const nifcToken = getNifcToken();
      return new Promise((resolve, reject) => {
        new Request().makeRequest({
            url: rootServiceUrl + "/" + config.userCustomFilters[config.env].layerId + "/updateFeatures",
            method: 'post',
            data: {
                f: 'json',
                token: nifcToken,
                features: JSON.stringify(customFilterInfo)
            }
        }).then(
            resp => {
                resolve(resp)
            },
            error => {
              reject(error)
            }
        );
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  deleteCustomFilter: function (objectID) {   
    try
    {
      const rootServiceUrl = getAttributeServiceUrl()
      const config = getAppConfig();
      const nifcToken = getNifcToken();
      return new Promise((resolve, reject) => {
        const whereClause = `(OBJECTID = ${objectID})`
          new Request().makeRequest({
              url: rootServiceUrl + "/" + config.userCustomFilters[config.env].layerId + "/deleteFeatures",
              method: 'post',
              data: {
                  f: 'json',
                  token: nifcToken,
                  where: whereClause
              }
          }).then(
              resp => {
                  resolve(resp)
              },
              error => {
                reject(error)
              }
          ); 
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  deleteAllCustomFiltersByUser: function (userId) {
    try
    {
      const rootServiceUrl = getAttributeServiceUrl()
      const config = getAppConfig();
      const nifcToken = getNifcToken();
      //Using this to delete roles before adding new ones
      return new Promise((resolve, reject) => {
        const whereClause = `(UserID = '${userId}')`;
          new Request().makeRequest({
              url: rootServiceUrl + "/" + config.userCustomFilters[config.env].layerId + "/deleteFeatures",
              method: 'post',
              data: {
                  f: 'json',
                  token: nifcToken,
                  where: whereClause
              }
          }).then(
              resp => {
                  resolve(resp)
              },
              error => {
                reject(error)
              }
          );
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  searchForUser: function(searchString){
    const rootServiceUrl = getAttributeServiceUrl()
    const config = getAppConfig();
    const queryObject = new Query({
      where: `(NifcUsername = '${searchString}')`,
      outFields: "NifcUsername, UserID, ID",
      returnGeometry: false,
    });
    return GeneralService.queryCallDirect(rootServiceUrl + "/" + config.users[config.env].layerId, queryObject).then(results => {
      let foundUsers = [];
      if(results.features) {
        foundUsers = results.features.map((eaItem) => eaItem.attributes);
      } 
      return foundUsers;
    }, function(error){
      return new Promise((resolve,reject) => {
        reject(error);
      });
    });
  },
  shareUserFilter: function(filterForSave) {
    const rootServiceUrl = getAttributeServiceUrl()
    const config = getAppConfig();
    const nifcToken = getNifcToken();
    return new Promise((resolve, reject) => {
      new Request().makeRequest({
        url: rootServiceUrl + "/" + config.userCustomFilters[config.env].layerId + "/addFeatures",
        method: 'post',
        data: {
            f: 'json',
            token: nifcToken,
            features: JSON.stringify([filterForSave])
        }
      }).then(
          resp => {
            resolve(resp)
          },
          error => {
            reject(error)
          }
      );
    });
  }
};

export default CustomFilterService;